var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebarText.jinja"] = require( "front/components/CommonSidebar/CommonSidebarText.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebarImage.jinja"] = require( "front/components/CommonSidebar/CommonSidebarImage.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebarDocument.jinja"] = require( "front/components/CommonSidebar/CommonSidebarDocument.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebarIssue.jinja"] = require( "front/components/CommonSidebar/CommonSidebarIssue.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonSidebar/CommonSidebar.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonSidebar/CommonSidebar.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebarText.jinja", false, "assets/app/front/components/CommonSidebar/CommonSidebar.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonSidebarText")) {
var t_7 = t_4.CommonSidebarText;
} else {
cb(new Error("cannot import 'CommonSidebarText'")); return;
}
context.setVariable("CommonSidebarText", t_7);
output += "\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebarImage.jinja", false, "assets/app/front/components/CommonSidebar/CommonSidebar.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "CommonSidebarImage")) {
var t_11 = t_8.CommonSidebarImage;
} else {
cb(new Error("cannot import 'CommonSidebarImage'")); return;
}
context.setVariable("CommonSidebarImage", t_11);
output += "\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebarDocument.jinja", false, "assets/app/front/components/CommonSidebar/CommonSidebar.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "CommonSidebarDocument")) {
var t_15 = t_12.CommonSidebarDocument;
} else {
cb(new Error("cannot import 'CommonSidebarDocument'")); return;
}
context.setVariable("CommonSidebarDocument", t_15);
output += "\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebarIssue.jinja", false, "assets/app/front/components/CommonSidebar/CommonSidebar.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "CommonSidebarIssue")) {
var t_19 = t_16.CommonSidebarIssue;
} else {
cb(new Error("cannot import 'CommonSidebarIssue'")); return;
}
context.setVariable("CommonSidebarIssue", t_19);
output += "\n\n";
var macro_t_20 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_21 = "";t_21 += "\n    <div class=\"CommonSidebar\">\n        ";
frame = frame.push();
var t_24 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content");
if(t_24) {t_24 = runtime.fromIterator(t_24);
var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("CommonSidebar", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
t_21 += "\n            ";
if(runtime.memberLookup((t_25),"component") == "text") {
t_21 += "\n                ";
t_21 += runtime.suppressValue((lineno = 11, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebarText"), "CommonSidebarText", context, [runtime.makeKeywordArgs({"data": {"content": t_25}})])), env.opts.autoescape);
t_21 += "\n            ";
;
}
t_21 += "\n\n            ";
if(runtime.memberLookup((t_25),"component") == "image") {
t_21 += "\n                ";
t_21 += runtime.suppressValue((lineno = 15, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebarImage"), "CommonSidebarImage", context, [runtime.makeKeywordArgs({"data": {"content": t_25}})])), env.opts.autoescape);
t_21 += "\n            ";
;
}
t_21 += "\n\n            ";
if(runtime.memberLookup((t_25),"component") == "file") {
t_21 += "\n                ";
t_21 += runtime.suppressValue((lineno = 19, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebarDocument"), "CommonSidebarDocument", context, [runtime.makeKeywordArgs({"data": {"content": t_25}})])), env.opts.autoescape);
t_21 += "\n            ";
;
}
t_21 += "\n\n            ";
if(runtime.memberLookup((t_25),"component") == "issue" && runtime.memberLookup((t_25),"issue")) {
t_21 += "\n                ";
t_21 += runtime.suppressValue((lineno = 23, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebarIssue"), "CommonSidebarIssue", context, [runtime.makeKeywordArgs({"data": {"content": t_25}})])), env.opts.autoescape);
t_21 += "\n            ";
;
}
t_21 += "\n        ";
;
}
}
frame = frame.pop();
t_21 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_21);
});
context.addExport("CommonSidebar");
context.setVariable("CommonSidebar", macro_t_20);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonSidebar/CommonSidebar.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonSidebar/CommonSidebar.jinja
// module id = 12
// module chunks = 0